import ActivityAPI from './activity.api'

export default ActivityAPI
